import * as React from 'react';
// import * as PropTypes from 'prop-types';
import hoistNonReactStatics from 'hoist-non-react-statics';
import getInjectors from './reducerInjectors';
import { InjectReducerParams } from 'types';
import { ReactReduxContext } from 'react-redux';

/**
 * Dynamically injects a reducer
 *
 * @param {string} key A key of the reducer
 * @param {function} reducer A reducer that will be injected
 *
 */

export default function hocWithReducer<P>({ key, reducer }: InjectReducerParams) {
  function wrap(WrappedComponent: React.ComponentType<P>): React.ComponentType<P> {
    // dont wanna give access to HOC. Child only
    class ReducerInjector extends React.Component<P> {
      static WrappedComponent = WrappedComponent;
      // static contextTypes = {
      //   store: PropTypes.object.isRequired,
      // };
      static contextType = ReactReduxContext;
      static displayName = `withReducer(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;

      componentWillMount() {
        const { injectReducer } = this.injectors;

        injectReducer(key, reducer);
      }

      injectors = getInjectors(this.context.store);

      render() {
        return <WrappedComponent {...this.props} />;
      }
    }

    return hoistNonReactStatics(ReducerInjector, WrappedComponent) as any;
  }
  return wrap;
}
